<nav
    *ngIf="pagesRange"
    aria-label="paginator"
>
    <ul class="pagination justify-content-center">
        <li
            class="page-item"
            [ngClass]="{'disabled': currentPage === 1}"
        >
            <a
                *ngIf="currentPage !== 1; else disabledPrevious"
                (click)="getPrevious()"
                class="page-link"
                tabindex="-1"
            >
                < 
            </a>
            <ng-template #disabledPrevious>
                <a
                    href="javascript:void('0');"
                    class="page-link"
                    tabindex="-1"
                >
                    < 
                </a>
            </ng-template>
        </li>

        <li
            *ngIf="config.pagesChunk > defaultPagesChunk"
            class="page-item"
        >
            <a
                (click)="getChunk(config.pagesChunk - 1, false)"
                class="page-link"
            >...</a>
        </li>

        <li
            *ngFor="let page of pagesRange"
            [ngClass]="{'active': (currentPage === page) && (lastPage !== defaultPage)}"
            class="page-item"
        >
            <a
                *ngIf="lastPage !== defaultPage; else disabledPage"
                (click)="changePage(page)"
                class="page-link"
            >
                {{ page }}
            </a>
            <ng-template #disabledPage>
                <a class="page-link disabled">
                    {{ page }}
                </a>
            </ng-template>
        </li>

        <li
            *ngIf="config.totalItems > (config.itemsPerPage * defaultMaxPagesPerChunk)"
            class="page-item"
        >
            <a
                (click)="getChunk(config.pagesChunk + 1, true)"
                class="page-link"
            >...</a>
        </li>

        <li
            class="page-item"
            [ngClass]="{'disabled': (currentPage === lastPage) && !hasNextPagesChunk}"
        >

            <a
                *ngIf="isNextEnabled(); else disabledNext"
                (click)="getNext()"
                class="page-link"
                tabindex="-1"
            >
                >
            </a>
            <ng-template #disabledNext>
                <a
                    href="javascript:void('0');"
                    class="page-link"
                    tabindex="-1"
                >
                    >
                </a>
            </ng-template>
        </li>
    </ul>
</nav>